module.exports = __webpack_public_path__ + "img/logo3.cb223ee9.png";